import { useLazyQuery } from '@apollo/client'

import { useApolloQueryErrorHandling } from '@sputnik/apollo/useApolloQueryErrorHandling'
import GetRequiredDocs from '@sputnik/pages/Dashboard/gql/GetRequiredDocs.gql'

const useGetRequiredDocs = (salesforceCreditId) => {
  const [getRequiredDocs, { error, ...rest }] = useLazyQuery(GetRequiredDocs, {
    // Do not update the initial cache so we can compare initially requested docs versus remaining docs
    fetchPolicy: 'no-cache',
    variables: { salesforceCreditId },
  })

  useApolloQueryErrorHandling({
    error,
    logging: {
      eventName: 'Refetch',
      message: 'Error while refetching required documents from the uploader',
      action: 'getRequiredDocs',
      attributes: {
        creditAppId: salesforceCreditId,
      },
    },
  })

  return [getRequiredDocs, { error, ...rest }]
}

export default useGetRequiredDocs
